<svg xmlns="http://www.w3.org/2000/svg" class="bs-sprite" aria-hidden="true" focusable="false">
  

  
  <symbol id="bs-i-phone" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8.1 9.6a16 16 0 0 0 6 6l1.1-1.1a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2Z"></path>
  </symbol>
  <symbol id="bs-i-mail" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2.5" y="4.5" width="19" height="15" rx="2"></rect>
    <path d="m3 6 9 6 9-6"></path>
  </symbol>
  <symbol id="bs-i-info" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="9"></circle>
    <path d="M12 11v5"></path>
    <path d="M12 8h.01"></path>
  </symbol>
  <symbol id="bs-i-truck" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="1" y="6" width="13" height="10" rx="1.5"></rect>
    <path d="M14 9h4l3 3v4h-7z"></path>
    <circle cx="6" cy="18" r="1.8"></circle>
    <circle cx="17.5" cy="18" r="1.8"></circle>
  </symbol>
  <symbol id="bs-i-pin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20 10c0 6-8 11-8 11s-8-5-8-11a8 8 0 0 1 16 0Z"></path>
    <circle cx="12" cy="10" r="2.6"></circle>
  </symbol>
  <symbol id="bs-i-search" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="11" cy="11" r="7"></circle>
    <path d="m21 21-4.3-4.3"></path>
  </symbol>
  <symbol id="bs-i-user" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="8" r="4"></circle>
    <path d="M4 21a8 8 0 0 1 16 0"></path>
  </symbol>
  <symbol id="bs-i-cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="9" cy="20" r="1.4"></circle>
    <circle cx="18" cy="20" r="1.4"></circle>
    <path d="M2 3h2.2l2.3 12.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L21 7H6"></path>
  </symbol>
  <symbol id="bs-i-grid" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1"></rect>
    <rect x="14" y="3" width="7" height="7" rx="1"></rect>
    <rect x="3" y="14" width="7" height="7" rx="1"></rect>
    <rect x="14" y="14" width="7" height="7" rx="1"></rect>
  </symbol>
  <symbol id="bs-i-chevron-down" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="m6 9 6 6 6-6"></path>
  </symbol>
  <symbol id="bs-i-arrow-right" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6"></path>
  </symbol>
  <symbol id="bs-i-menu" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </symbol>
  <symbol id="bs-i-close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M18 6 6 18M6 6l12 12"></path>
  </symbol>
  <symbol id="bs-i-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="m4.5 12.5 5 5 10-11"></path>
  </symbol>
  <symbol id="bs-i-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 5v14M5 12h14"></path>
  </symbol>
  <symbol id="bs-i-battery" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2.5" y="7.5" width="16" height="9" rx="2"></rect>
    <line x1="21" y1="10.5" x2="21" y2="13.5"></line>
  </symbol>

  
  <symbol id="bs-i-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="11" width="16" height="10" rx="2.5"></rect>
    <path d="M8 11V7a4 4 0 0 1 8 0v4"></path>
  </symbol>
  <symbol id="bs-i-clock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="9"></circle>
    <path d="M12 7v5l3 2"></path>
  </symbol>
  <symbol id="bs-i-calendar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.5"></rect>
    <path d="M3.5 10h17M8 3v4M16 3v4"></path>
  </symbol>
  <symbol id="bs-i-headset" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 13v-1a8 8 0 0 1 16 0v1"></path>
    <rect x="3" y="13" width="4" height="6" rx="2"></rect>
    <rect x="17" y="13" width="4" height="6" rx="2"></rect>
    <path d="M20 19a3 3 0 0 1-3 3h-2"></path>
  </symbol>
  <symbol id="bs-i-chat" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </symbol>
  <symbol id="bs-i-shield" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 22s8-3.5 8-10V5l-8-3-8 3v7c0 6.5 8 10 8 10z"></path>
    <path d="m9 12 2 2 4-4"></path>
  </symbol>
  <symbol id="bs-i-refresh" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M23 4v6h-6M1 20v-6h6"></path>
    <path d="M3.5 9a9 9 0 0 1 14.9-3.4L23 10M1 14l4.6 4.4A9 9 0 0 0 20.5 15"></path>
  </symbol>
  <symbol id="bs-i-rosette" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="8" r="6"></circle>
    <path d="M8.2 13.9 7 22l5-3 5 3-1.2-8.1"></path>
  </symbol>
  <symbol id="bs-i-card" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2.5"></rect>
    <path d="M2 10h20"></path>
  </symbol>
  <symbol id="bs-i-arrow-left" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
    <path d="M19 12H5M11 18l-6-6 6-6"></path>
  </symbol>

  
  <symbol id="bs-i-bolt" viewBox="0 0 24 24" fill="currentColor">
    <path d="m13 2-9 11h6l-1 9 9-11h-6z"></path>
  </symbol>
  <symbol id="bs-i-star" viewBox="0 0 24 24" fill="currentColor">
    <path d="m12 17.3 5.2 3.1-1.4-5.9 4.6-4-6-.5L12 4 9.6 9.9l-6 .5 4.6 4-1.4 5.9z"></path>
  </symbol>  <symbol id="bs-i-photo" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="4.5" width="18" height="15" rx="2"></rect>
    <circle cx="8.7" cy="9.7" r="1.7"></circle>
    <path d="m21 15.5-4.6-4.6L9 18.4"></path>
  </symbol>
  <symbol id="bs-i-store" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 9.5 5.5 4h13L20 9.5"></path>
    <path d="M3 9.5h18"></path>
    <path d="M5 9.5V20h14V9.5"></path>
    <path d="M10 20v-5.5h4V20"></path>
  </symbol>
  <symbol id="bs-i-percent" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M19 5 5 19"></path>
    <circle cx="6.8" cy="6.8" r="2.6"></circle>
    <circle cx="17.2" cy="17.2" r="2.6"></circle>
  </symbol>
  <symbol id="bs-i-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"></path>
  </symbol>
  <symbol id="bs-i-package" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
    <path d="m3.3 7 8.7 5 8.7-5"></path>
    <path d="M12 22V12"></path>
  </symbol>
  <symbol id="bs-i-leaf" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path>
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
  </symbol>
  <symbol id="bs-i-wrench" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
  </symbol>
  <symbol id="bs-i-hammer" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9"></path>
    <path d="m18 15 4-4"></path>
    <path d="m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5"></path>
  </symbol>
  <symbol id="bs-i-car" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"></path>
    <circle cx="7" cy="17" r="2"></circle>
    <path d="M9 17h6"></path>
    <circle cx="17" cy="17" r="2"></circle>
  </symbol>
  <symbol id="bs-i-home" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2h-3v-8h-8v8H5a2 2 0 0 1-2-2z"></path>
  </symbol>
  <symbol id="bs-i-gift" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="8" width="18" height="4" rx="1"></rect>
    <path d="M12 8v13"></path>
    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"></path>
  </symbol>
  <symbol id="bs-i-file" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M14 2.5H6.5A1.5 1.5 0 0 0 5 4v16a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 19 20V7.5z"></path>
    <path d="M14 2.5V7.5H19"></path>
    <path d="M8.5 13h7M8.5 16.5h7M8.5 9.5h2"></path>
  </symbol>
  <symbol id="bs-i-map" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m9 3.5-6 2.5v14l6-2.5 6 2.5 6-2.5v-14L15 6 9 3.5z"></path>
    <path d="M9 3.5v14M15 6v14"></path>
  </symbol>
  <symbol id="bs-i-play" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="9.2"></circle>
    <path d="M10 8.5v7l6-3.5z" fill="currentColor" stroke="none"></path>
  </symbol>
  <symbol id="bs-i-filter" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 5h18l-7 8v6l-4-2v-4z"></path>
  </symbol>
  <symbol id="bs-i-key" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="7.5" cy="14.5" r="4"></circle>
    <path d="m10.3 11.7 8.2-8.2M15 6l2.5 2.5M18 3l2.5 2.5"></path>
  </symbol>
  <symbol id="bs-i-cog" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="3.2"></circle>
    <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 0 1-4 0v-.1A1.6 1.6 0 0 0 7 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7H1a2 2 0 0 1 0-4h.1A1.6 1.6 0 0 0 2.6 7a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 7 2.6h.1A1.6 1.6 0 0 0 8.1 1V1a2 2 0 0 1 4 0v.1A1.6 1.6 0 0 0 15 2.6a1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-1.1 2.7v.1A1.6 1.6 0 0 0 21 8.1h.1a2 2 0 0 1 0 4H21a1.6 1.6 0 0 0-1.5 1z"></path>
  </symbol>
  <symbol id="bs-i-tag" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20.5 13.3 13.3 20.5a1.5 1.5 0 0 1-2.1 0L3 12.3V3h9.3l8.2 8.2a1.5 1.5 0 0 1 0 2.1z"></path>
    <circle cx="7.5" cy="7.5" r="1.4"></circle>
  </symbol>

  <!-- Doplněno proti handoff spritu (otevřený bod č. 7): toggle viditelnosti
       hesla v přihlášení a registraci měl v mockupech provizorium. -->
  <symbol id="bs-i-eye" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </symbol>
  <symbol id="bs-i-eye-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9.9 5.7A9.9 9.9 0 0 1 12 5.5c6.4 0 10 6.5 10 6.5a17.7 17.7 0 0 1-3.4 4.2"></path>
    <path d="M6.3 7.8A17.6 17.6 0 0 0 2 12s3.6 6.5 10 6.5a10 10 0 0 0 4-.8"></path>
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"></path>
    <path d="M3 3l18 18"></path>
  </symbol>
  <symbol id="bs-i-trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 7h16"></path>
    <path d="M9.5 7V4.8c0-.4.4-.8.8-.8h3.4c.4 0 .8.4.8.8V7"></path>
    <path d="M6.5 7l.8 12.2c0 .5.4.8.9.8h7.6c.5 0 .9-.3.9-.8L17.5 7"></path>
    <path d="M10.3 11v5.5"></path>
    <path d="M13.7 11v5.5"></path>
  </symbol>

  <!-- Ikony root kategorií mobilního menu (design_handoff_mobilni_menu/sprite.svg,
       2026-08-31). Lucide-like outline, převzato 1:1 z handoveru. -->
  <symbol id="bs-i-sprout" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7 20h10"></path>
    <path d="M10 20c5.5-2.5.8-6.4 3-10"></path>
    <path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"></path>
    <path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"></path>
  </symbol>
  <symbol id="bs-i-bricks" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"></rect>
    <path d="M3 9h18"></path>
    <path d="M3 15h18"></path>
    <path d="M12 3v6"></path>
    <path d="M8 9v6M16 9v6"></path>
    <path d="M12 15v6"></path>
  </symbol>
  <symbol id="bs-i-armchair" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3"></path>
    <path d="M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z"></path>
    <path d="M5 18v2M19 18v2"></path>
  </symbol>
  <symbol id="bs-i-swing" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4.5 3.5h15"></path>
    <path d="M4.5 3.5 2.5 20.5"></path>
    <path d="m19.5 3.5 2 17"></path>
    <path d="M9 3.5V14"></path>
    <path d="M15 3.5V14"></path>
    <path d="M8 14h8"></path>
  </symbol>
  <symbol id="bs-i-tree" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 2l4.5 6H14l4 5.5h-3l4 6H5l4-6H6L10 8H7.5z"></path>
    <path d="M12 19.5V22"></path>
  </symbol>
  <symbol id="bs-i-helmet" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"></path>
    <path d="M4 15v-3a6 6 0 0 1 6-6"></path>
    <path d="M14 6a6 6 0 0 1 6 6v3"></path>
    <rect x="2" y="15" width="20" height="4" rx="1"></rect>
  </symbol>
  <symbol id="bs-i-solar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5.5 4h13L21 14H3z"></path>
    <path d="M12 4v10"></path>
    <path d="M6.6 9h10.8"></path>
    <path d="M12 14v6"></path>
    <path d="M8 20h8"></path>
  </symbol>

  <!-- Ikony skupin megamenu (2026-08-31, zadání Tomáše) — stejný jazyk jako
       root sada: 24×24, stroke 1.7–2, round cap/join. Mapování drží
       GROUP_ICON_RULES v menuModel.js. -->
  <symbol id="bs-i-chainsaw" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="9" y="6" width="13" height="5" rx="2.5"></rect>
    <path d="M12 8.5h7"></path>
    <path d="M3 9h6v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <path d="M3 12h6"></path>
  </symbol>
  <symbol id="bs-i-trimmer" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 3 9.5 14.5"></path>
    <path d="m14 7 2.5 2.5"></path>
    <circle cx="7" cy="17" r="3.4"></circle>
    <path d="M2 21.5c.9-.4 1.5-1 2-2"></path>
    <path d="M12.5 21.5c-.9-.4-1.5-1-2-2"></path>
  </symbol>
  <symbol id="bs-i-mower" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 4l-4.5 7"></path>
    <rect x="3.5" y="11" width="13" height="4.5" rx="1.5"></rect>
    <circle cx="6.5" cy="18.6" r="1.9"></circle>
    <circle cx="14" cy="18.6" r="1.9"></circle>
  </symbol>
  <symbol id="bs-i-droplets" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7.5 16.5c2 0 3.7-1.6 3.7-3.7 0-1.4-1.2-3.3-3.7-5.8-2.5 2.5-3.7 4.4-3.7 5.8 0 2.1 1.7 3.7 3.7 3.7Z"></path>
    <path d="M14.5 3.5c2.3 2.3 4.6 4.5 4.6 7.1a4.6 4.6 0 0 1-8 3.1"></path>
    <path d="M14.5 3.5c-.6 1.4-1.4 2.6-2.3 3.6"></path>
  </symbol>
  <symbol id="bs-i-shovel" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m17 2 5 5-1 1a3.2 3.2 0 0 1-4.5 0 3.2 3.2 0 0 1 0-4.5Z"></path>
    <path d="M17.5 6.5 9 15"></path>
    <path d="M2 22v-4.5L6.5 13l4.5 4.5L6.5 22Z"></path>
  </symbol>
  <symbol id="bs-i-drill" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="5" width="12" height="6" rx="1.5"></rect>
    <path d="M15 8h6"></path>
    <path d="M7 11l1.2 6.5a1.5 1.5 0 0 0 1.5 1.2H12l-.8-7.7"></path>
  </symbol>
  <symbol id="bs-i-plant" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6.5 14h11l-1.2 7h-8.6z"></path>
    <path d="M12 14V9"></path>
    <path d="M12 9c0-3-2-5-5.5-5C6.5 7.5 8.5 9 12 9Z"></path>
    <path d="M12 9c0-3 2-5 5.5-5 0 3.5-2 5-5.5 5Z"></path>
  </symbol>
  <symbol id="bs-i-wheelbarrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 8h14l-2.3 6.5H6.5z"></path>
    <circle cx="11" cy="18.5" r="2.3"></circle>
    <path d="m17.5 8 4-1.5"></path>
    <path d="M6.5 14.5 4 19"></path>
  </symbol>
  <symbol id="bs-i-handsaw" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M2.5 10 17 4.5l4.5 4.6L8 14.5H5z"></path>
    <path d="M8 14.5 6.5 19.5H3.8L5 14.5"></path>
  </symbol>
  <symbol id="bs-i-fence" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6 21V5.5L4 3.5 2 5.5V21z"></path>
    <path d="M14 21V5.5l-2-2-2 2V21z"></path>
    <path d="M22 21V5.5l-2-2-2 2V21z"></path>
    <path d="M6 10h4"></path>
    <path d="M14 10h4"></path>
    <path d="M6 16h4"></path>
    <path d="M14 16h4"></path>
  </symbol>
  <symbol id="bs-i-waves" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M2 6.5c.7.6 1.4 1 2.6 1C7 7.5 7 5.5 9.5 5.5s2.4 2 5 2 2.5-2 5-2c1.2 0 1.8.4 2.5 1"></path>
    <path d="M2 12.5c.7.6 1.4 1 2.6 1 2.4 0 2.4-2 4.9-2s2.4 2 5 2 2.5-2 5-2c1.2 0 1.8.4 2.5 1"></path>
    <path d="M2 18.5c.7.6 1.4 1 2.6 1 2.4 0 2.4-2 4.9-2s2.4 2 5 2 2.5-2 5-2c1.2 0 1.8.4 2.5 1"></path>
  </symbol>
  <symbol id="bs-i-layers" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m12 2.5 8.5 4.5L12 11.5 3.5 7z"></path>
    <path d="m3.5 12 8.5 4.5 8.5-4.5"></path>
    <path d="m3.5 17 8.5 4.5 8.5-4.5"></path>
  </symbol>
  <symbol id="bs-i-spray" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="6" y="9" width="8.5" height="12" rx="1.8"></rect>
    <path d="M8.5 9V6.5h3.5V9"></path>
    <path d="M9 4h2.5"></path>
    <path d="M17.5 5h.01"></path>
    <path d="M21 4h.01"></path>
    <path d="M20 8h.01"></path>
    <path d="M17.5 11h.01"></path>
  </symbol>
  <symbol id="bs-i-bird" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M16 7h.01"></path>
    <path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.3-2.3L2 20"></path>
    <path d="m20 7 2 .5-2 .5"></path>
    <path d="M10 18v3"></path>
    <path d="M14 17.75V21"></path>
  </symbol>
  <symbol id="bs-i-gauge" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m12 14 4-4"></path>
    <path d="M3.34 19a10 10 0 1 1 17.32 0"></path>
  </symbol>
  <symbol id="bs-i-bug" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 20a5 5 0 0 0 5-5v-3a5 5 0 0 0-10 0v3a5 5 0 0 0 5 5Z"></path>
    <path d="m9 7.5-2-3"></path>
    <path d="m15 7.5 2-3"></path>
    <path d="M7 13H3"></path>
    <path d="M17 13h4"></path>
    <path d="m8 17-3 2.5"></path>
    <path d="m16 17 3 2.5"></path>
  </symbol>
  <symbol id="bs-i-wind" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M17.7 7.7A2.5 2.5 0 1 1 19.5 12H2"></path>
    <path d="M9.6 4.6A2 2 0 1 1 11 8H2"></path>
    <path d="M12.6 19.4A2 2 0 1 0 14 16H2"></path>
  </symbol>
  <symbol id="bs-i-greenhouse" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 20v-6a9 8.5 0 0 1 18 0v6"></path>
    <path d="M2 20h20"></path>
    <path d="M12 5.5V20"></path>
    <path d="M7 8V20"></path>
    <path d="M17 8v12"></path>
  </symbol>
  <symbol id="bs-i-sack" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9.5 6C9.5 8 5.5 9.5 5.5 14a6.5 6.5 0 0 0 13 0c0-4.5-4-6-4-8"></path>
    <path d="m9.5 6-1.5-3h8l-1.5 3z"></path>
  </symbol>
  <symbol id="bs-i-sparkles" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m12 3 1.9 5.1a2 2 0 0 0 1.2 1.2L20.2 11l-5.1 1.9a2 2 0 0 0-1.2 1.2L12 19.2l-1.9-5.1a2 2 0 0 0-1.2-1.2L3.8 11l5.1-1.9a2 2 0 0 0 1.2-1.2Z"></path>
    <path d="M5 3.5v3"></path>
    <path d="M3.5 5h3"></path>
    <path d="M19 17.5v3"></path>
    <path d="M17.5 19h3"></path>
  </symbol>
  <symbol id="bs-i-flame" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.07-2.14-.22-4.05 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.15.43-2.29 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
  </symbol>
  <symbol id="bs-i-droplet" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"></path>
  </symbol>
  <symbol id="bs-i-broom" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m20 3-7.2 7.2"></path>
    <path d="M12.8 10.2c2.3 1.5 3.3 3.2 2.8 5.3L13 18.1c-3 1.3-6.5 1-9.5-.6 1-3.3 2.7-6 5.4-7.5 1.6-.4 2.7 0 3.9.2Z"></path>
    <path d="m9 15-1.5 1.8"></path>
  </symbol>
  <symbol id="bs-i-plug" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 22v-5"></path>
    <path d="M9 8V2"></path>
    <path d="M15 8V2"></path>
    <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"></path>
  </symbol>
  <symbol id="bs-i-welding" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7 3h10a2 2 0 0 1 2 2v9a7 7 0 0 1-14 0V5a2 2 0 0 1 2-2Z"></path>
    <rect x="8" y="9.5" width="8" height="3.4" rx="1"></rect>
  </symbol>
  <symbol id="bs-i-compressor" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3.5" y="9.5" width="13" height="7.5" rx="3.7"></rect>
    <circle cx="7.5" cy="19.6" r="1.4"></circle>
    <circle cx="12.5" cy="19.6" r="1.4"></circle>
    <path d="M12 9.5V6.5h5"></path>
    <circle cx="19" cy="6.5" r="2"></circle>
  </symbol>
  <symbol id="bs-i-hook" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="4" r="1.7"></circle>
    <path d="M12 5.7V11"></path>
    <path d="M12 11a4.7 4.7 0 1 0 4.7 4.7V14"></path>
  </symbol>
  <symbol id="bs-i-trolley" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4.5 2.5h2v13.5"></path>
    <path d="m6.5 16 2.7 3H21"></path>
    <circle cx="8.5" cy="20.5" r="1.6"></circle>
    <rect x="9.5" y="7" width="7.5" height="6" rx="1"></rect>
    <path d="M6.5 13h3"></path>
  </symbol>
  <symbol id="bs-i-ruler" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21.3 8.7 8.7 21.3a1 1 0 0 1-1.4 0l-4.6-4.6a1 1 0 0 1 0-1.4L15.3 2.7a1 1 0 0 1 1.4 0l4.6 4.6a1 1 0 0 1 0 1.4Z"></path>
    <path d="m7.5 10.5 2 2"></path>
    <path d="m10.5 7.5 2 2"></path>
    <path d="m13.5 4.5 2 2"></path>
    <path d="m4.5 13.5 2 2"></path>
  </symbol>
  <symbol id="bs-i-drawers" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="3" width="16" height="18" rx="2"></rect>
    <path d="M4 9h16"></path>
    <path d="M4 15h16"></path>
    <path d="M10.5 6h3"></path>
    <path d="M10.5 12h3"></path>
    <path d="M10.5 18h3"></path>
  </symbol>
  <symbol id="bs-i-saw-blade" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="7.5"></circle>
    <circle cx="12" cy="12" r="2"></circle>
    <path d="M12 2.5v2"></path>
    <path d="M12 19.5v2"></path>
    <path d="M2.5 12h2"></path>
    <path d="M19.5 12h2"></path>
    <path d="m5.3 5.3 1.4 1.4"></path>
    <path d="m17.3 17.3 1.4 1.4"></path>
    <path d="m5.3 18.7 1.4-1.4"></path>
    <path d="m17.3 6.7 1.4-1.4"></path>
  </symbol>
  <symbol id="bs-i-paint-roller" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2.5" y="2.5" width="15" height="6" rx="2"></rect>
    <path d="M10 15.5v-1.5a2 2 0 0 1 2-2h7.5a2 2 0 0 0 2-2V7.5a2 2 0 0 0-2-2h-2"></path>
    <rect x="8" y="15.5" width="4" height="6" rx="1"></rect>
  </symbol>
  <symbol id="bs-i-ladder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 2.5v19"></path>
    <path d="M16 2.5v19"></path>
    <path d="M8 7h8"></path>
    <path d="M8 12h8"></path>
    <path d="M8 17h8"></path>
  </symbol>
  <symbol id="bs-i-shelf" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 2.5v19"></path>
    <path d="M20 2.5v19"></path>
    <path d="M4 8.5h16"></path>
    <path d="M4 15.5h16"></path>
    <rect x="8" y="11" width="5" height="4.5" rx="0.5"></rect>
  </symbol>
  <symbol id="bs-i-utensils" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 2.5V9a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2.5"></path>
    <path d="M7.5 2.5V21.5"></path>
    <path d="M20.5 14.5V2.5a4.5 4.5 0 0 0-4.5 4.5v5.5a2 2 0 0 0 2 2h2.5Zm0 0v7"></path>
  </symbol>
  <symbol id="bs-i-bath" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 12h18v3a4.5 4.5 0 0 1-4.5 4.5h-9A4.5 4.5 0 0 1 3 15z"></path>
    <path d="M6 19.5 5 21.5"></path>
    <path d="m18 19.5 1 2"></path>
    <path d="M5.5 12V5.5a2.2 2.2 0 0 1 4.4 0"></path>
  </symbol>
  <symbol id="bs-i-briefcase" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="7" width="18" height="13" rx="2"></rect>
    <path d="M8.5 7V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2"></path>
    <path d="M3 12.5h18"></path>
  </symbol>
  <symbol id="bs-i-tent" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 21 14 3"></path>
    <path d="M20.5 21 10 3"></path>
    <path d="M15.5 21 12 15l-3.5 6"></path>
    <path d="M2 21h20"></path>
  </symbol>
  <symbol id="bs-i-cpu" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="6" y="6" width="12" height="12" rx="1.5"></rect>
    <rect x="10" y="10" width="4" height="4"></rect>
    <path d="M9 3.5V6"></path>
    <path d="M15 3.5V6"></path>
    <path d="M9 18v2.5"></path>
    <path d="M15 18v2.5"></path>
    <path d="M3.5 9H6"></path>
    <path d="M3.5 15H6"></path>
    <path d="M18 9h2.5"></path>
    <path d="M18 15h2.5"></path>
  </symbol>
  <symbol id="bs-i-bulb" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9 18h6"></path>
    <path d="M10 21.5h4"></path>
    <path d="M15.1 14c.2-1 .65-1.74 1.4-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5.75.76 1.2 1.5 1.4 2.5"></path>
  </symbol>
  <symbol id="bs-i-grill" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 8h16a8 8 0 0 1-16 0Z"></path>
    <path d="m8.7 15.4-2.7 6.1"></path>
    <path d="m15.3 15.4 2.7 6.1"></path>
    <path d="M7.5 18.5h9"></path>
    <path d="M9 4.5V3"></path>
    <path d="M12 4.5V3"></path>
    <path d="M15 4.5V3"></path>
  </symbol>
  <symbol id="bs-i-paw" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="7.5" cy="6.5" r="1.7"></circle>
    <circle cx="16.5" cy="6.5" r="1.7"></circle>
    <circle cx="3.8" cy="11.5" r="1.7"></circle>
    <circle cx="20.2" cy="11.5" r="1.7"></circle>
    <path d="M12 11c-2.9 0-5.2 2.3-5.2 5.2 0 1.8 1.4 3.3 3.2 3.3.7 0 1.4-.3 2-.8.6.5 1.3.8 2 .8 1.8 0 3.2-1.5 3.2-3.3 0-2.9-2.3-5.2-5.2-5.2Z"></path>
  </symbol>
  <symbol id="bs-i-dumbbell" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m6.5 6.5 11 11"></path>
    <path d="m21 21-1.5-1.5"></path>
    <path d="m3 3 1.5 1.5"></path>
    <path d="m18.5 22 3.5-3.5"></path>
    <path d="m2 5.5 3.5-3.5"></path>
    <path d="m3.5 10.5 7-7"></path>
    <path d="m13.5 20.5 7-7"></path>
  </symbol>
  <symbol id="bs-i-shoe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M2 15.5v3h18.5a1.5 1.5 0 0 0 1.5-1.5c0-1.6-1.1-2.6-3.2-3.2l-4.6-1.4-3.2-3.9H5.5a3.5 3.5 0 0 0-3.5 3.5Z"></path>
    <path d="m10 10.5 1.7 2"></path>
    <path d="m7.2 11.5 1.5 1.8"></path>
  </symbol>
  <symbol id="bs-i-shirt" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20.4 3.5 16 2a4 4 0 0 1-8 0L3.6 3.5a2 2 0 0 0-1.3 2.2l.6 3.5a1 1 0 0 0 1 .8H6v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10h2.1a1 1 0 0 0 1-.8l.6-3.5a2 2 0 0 0-1.3-2.2z"></path>
  </symbol>
  <symbol id="bs-i-slide" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 21V5"></path>
    <path d="M9 21V5"></path>
    <path d="M5 9h4"></path>
    <path d="M5 13h4"></path>
    <path d="M9 5h3c.4 6.7 3.4 11 9 13.2l-.8 2"></path>
  </symbol>
  <symbol id="bs-i-scooter" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="5.5" cy="18" r="2.3"></circle>
    <circle cx="18.5" cy="18" r="2.3"></circle>
    <path d="M7.8 18h6.4l2.5-2.5"></path>
    <path d="M18.5 15.5 15.5 4h-3"></path>
  </symbol>
  <symbol id="bs-i-seesaw" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m3 13.5 18-4.5"></path>
    <path d="M12 11.7 9.5 18h5z"></path>
    <circle cx="4" cy="10.8" r="1.5"></circle>
    <circle cx="20" cy="6.8" r="1.5"></circle>
    <path d="M3 21h18"></path>
  </symbol>
  <symbol id="bs-i-gamepad" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6 12h4"></path>
    <path d="M8 10v4"></path>
    <path d="M15.5 13h.01"></path>
    <path d="M18 11h.01"></path>
    <path d="M17.32 5H6.68a4 4 0 0 0-3.98 3.59c-.08.7-.7 5.87-.7 7.41a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.4-1.4a2 2 0 0 1 1.42-.6h4.34a2 2 0 0 1 1.42.6L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.54-.62-6.71-.7-7.41A4 4 0 0 0 17.32 5z"></path>
  </symbol>
  <symbol id="bs-i-steering" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="9"></circle>
    <circle cx="12" cy="12" r="2.6"></circle>
    <path d="M12 14.6V21"></path>
    <path d="m3.6 9.2 5.9 1.9"></path>
    <path d="m20.4 9.2-5.9 1.9"></path>
  </symbol>
  <symbol id="bs-i-camera" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M14.5 4h-5L7.5 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.5z"></path>
    <circle cx="12" cy="13" r="3.2"></circle>
  </symbol>
  <symbol id="bs-i-wreath" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="13.5" r="7"></circle>
    <path d="M12 6.5 9.2 4.6V8z"></path>
    <path d="m12 6.5 2.8-1.9V8z"></path>
    <path d="M8.5 16.5h.01"></path>
    <path d="M15.5 16.5h.01"></path>
    <path d="M12 18.8h.01"></path>
  </symbol>
  <symbol id="bs-i-bauble" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="14" r="7"></circle>
    <rect x="10" y="4" width="4" height="3.2" rx="1"></rect>
    <path d="M12 4V2"></path>
    <path d="M5.6 12.5c2 1.5 4.3 1.5 6.4 0s4.4-1.5 6.4 0"></path>
  </symbol>
  <symbol id="bs-i-hand" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M18 11V6a2 2 0 0 0-4 0v5"></path>
    <path d="M14 10V4a2 2 0 0 0-4 0v6"></path>
    <path d="M10 10.5V6a2 2 0 0 0-4 0v8"></path>
    <path d="m7 15-1.8-1.8a2 2 0 0 0-2.8 2.8l3.6 3.6C7.5 21.1 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 0 0-4 0v5"></path>
  </symbol>
  <symbol id="bs-i-glasses" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="6" cy="15" r="3.6"></circle>
    <circle cx="18" cy="15" r="3.6"></circle>
    <path d="M14.4 15a2.4 2.4 0 0 0-4.8 0"></path>
    <path d="M2.5 13 5 7c.6-1.2 1.4-1.8 2.8-1.8"></path>
    <path d="M21.5 13 19 7c-.6-1.2-1.4-1.8-2.8-1.8"></path>
  </symbol>
  <symbol id="bs-i-mask" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 19.5c-3.9 0-7-2.3-7-5.7V9.5C5 7.9 8.1 6.5 12 6.5s7 1.4 7 3v4.3c0 3.4-3.1 5.7-7 5.7Z"></path>
    <path d="M5 10.5 2 9"></path>
    <path d="m19 10.5 3-1.5"></path>
    <path d="m5.3 15.5-3.3 1"></path>
    <path d="m18.7 15.5 3.3 1"></path>
    <path d="M9.5 10h5"></path>
    <circle cx="12" cy="14.5" r="1.6"></circle>
  </symbol>
  <!-- pokladna: hmotnostní pásmo dopravy + ikony plateb (mock 2026-09-02,
       ops/sweeps/2026-09-02-doprava-hmotnostni-tarif/mock-hmotnost-v-pokladne.html) -->
  <symbol id="bs-i-scale" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3v18"></path>
    <path d="M5 21h14"></path>
    <path d="M12 5l-6 2"></path>
    <path d="M12 5l6 2"></path>
    <path d="M6 7l-3 7a3.2 3.2 0 0 0 6 0z"></path>
    <path d="M18 7l-3 7a3.2 3.2 0 0 0 6 0z"></path>
  </symbol>
  <symbol id="bs-i-cash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="2.5" y="6" width="19" height="12" rx="2"></rect>
    <circle cx="12" cy="12" r="2.8"></circle>
    <path d="M6 9.5h.01"></path>
    <path d="M18 14.5h.01"></path>
  </symbol>
  <symbol id="bs-i-bank" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 9 12 4l9 5"></path>
    <path d="M4 9h16"></path>
    <path d="M5 9v8"></path>
    <path d="M9.5 9v8"></path>
    <path d="M14.5 9v8"></path>
    <path d="M19 9v8"></path>
    <path d="M3 20h18"></path>
  </symbol>
  <symbol id="bs-i-wallet" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H19v3.5"></path>
    <path d="M3 7.5V18a2 2 0 0 0 2 2h16v-9H5.5A2.5 2.5 0 0 1 3 8.5z"></path>
    <circle cx="16.5" cy="15.5" r="1.2"></circle>
  </symbol>
  <!-- Kotvy detailu produktu (zadání Tomáše 2026-09-05): každá sekce má vlastní
       glyph vlevo vedle textu pilulky; styl root sady (24×24, stroke 1.8, round).
       `book` nese i tlačítko Návod v kartě poradny a sekci návodu, `download`
       CTA „Stáhnout návod". -->
  <symbol id="bs-i-text" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 6.5h16"></path>
    <path d="M4 11h16"></path>
    <path d="M4 15.5h12"></path>
    <path d="M4 20h7"></path>
  </symbol>
  <symbol id="bs-i-sliders" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 7h8.5M18.5 7h2"></path>
    <circle cx="15" cy="7" r="2.2"></circle>
    <path d="M3.5 12h2M9 12h11.5"></path>
    <circle cx="7" cy="12" r="2.2"></circle>
    <path d="M3.5 17h10M20 17h.5"></path>
    <circle cx="17" cy="17" r="2.2"></circle>
  </symbol>
  <symbol id="bs-i-help" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="9"></circle>
    <path d="M9.4 9.4a2.7 2.7 0 0 1 5.2.9c0 1.8-2.6 2.2-2.6 4"></path>
    <path d="M12 17.6h.01"></path>
  </symbol>
  <symbol id="bs-i-book" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M2.5 3.5h6a3.5 3.5 0 0 1 3.5 3.5v13.5a2.6 2.6 0 0 0-2.6-2.6H2.5z"></path>
    <path d="M21.5 3.5h-6A3.5 3.5 0 0 0 12 7v13.5a2.6 2.6 0 0 1 2.6-2.6h6.9z"></path>
  </symbol>
  <symbol id="bs-i-star-line" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="m12 3.6 2.6 5.5 6 .7-4.4 4.1 1.2 6-5.4-3-5.4 3 1.2-6L3.4 9.8l6-.7z"></path>
  </symbol>
  <symbol id="bs-i-chats" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M14.5 9.5a2 2 0 0 1-2 2H6.5l-4 3.5v-11a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"></path>
    <path d="M18 9.5h1.5a2 2 0 0 1 2 2v10l-4-3.5h-6a2 2 0 0 1-2-2v-1"></path>
  </symbol>
  <symbol id="bs-i-badge" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.9 8.6a4 4 0 0 1 4.7-4.7 4 4 0 0 1 6.8 0 4 4 0 0 1 4.7 4.7 4 4 0 0 1 0 6.8 4 4 0 0 1-4.7 4.7 4 4 0 0 1-6.8 0 4 4 0 0 1-4.7-4.7 4 4 0 0 1 0-6.8z"></path>
    <path d="m9 12 2 2 4-4"></path>
  </symbol>
  <symbol id="bs-i-link" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10 13.5a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"></path>
    <path d="M14 10.5a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"></path>
  </symbol>
  <symbol id="bs-i-copy" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <rect x="9" y="9" width="12" height="12" rx="2.5"></rect>
    <path d="M5 15h-.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V5"></path>
  </symbol>
  <symbol id="bs-i-download" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3.5v12"></path>
    <path d="m7 10.5 5 5 5-5"></path>
    <path d="M4 20.5h16"></path>
  </symbol>
  <!-- Vlajky přepínače CZ ↔ SK (countrySwitch.js), poměr 3:2. Kresba = Wikimedia
       Commons Flag_of_the_Czech_Republic.svg a Flag_of_Slovakia.svg (volné dílo);
       barvy nesou cesty samy, currentColor se tu nepoužívá. -->
  <symbol id="bs-i-flag-cz" viewBox="0 0 900 600" preserveAspectRatio="xMidYMid slice">
    <path fill="#d7141a" d="M0 0h900v600H0z"></path>
    <path fill="#fff" d="M0 0h900v300H0z"></path>
    <path fill="#11457e" d="M450 300 0 0v600z"></path>
  </symbol>
  <symbol id="bs-i-flag-sk" viewBox="0 0 900 600" preserveAspectRatio="xMidYMid slice">
    <path fill="#254aa5" d="M0 400h900V200H0Z"></path>
    <path fill="#fff" d="M0 200h900V0H0Z"></path>
    <path fill="#ed1c24" d="M0 600h900V400H0Z"></path>
    <path fill="#fff" d="m269.993 459.98-3.906-1.867c-25.267-12.173-56.294-30.4-81.294-58.133-25-27.733-43.8-65.307-43.8-114.24 0-93.6 4.52-136.68 4.52-136.68l.84-8.067h247.28l.84 8.067s4.534 43.093 4.534 136.68c0 48.933-18.8 86.507-43.814 114.24-25 27.733-56.026 45.96-81.293 58.133Z"></path>
    <path fill="#ed1c24" d="M270 450c-49.38-23.76-120-70.94-120-164.25S154.46 150 154.46 150h231.07S390 192.44 390 285.75 319.37 426.24 270 450"></path>
    <path fill="#fff" d="M280.56 261.28c13.36.22 39.45.74 62.67-7.03 0 0-.61 8.31-.61 17.99 0 9.67.61 17.98.61 17.98-21.3-7.12-47.61-7.27-62.67-7.08v51.54h-21.12v-51.54c-15.07-.2-41.37-.04-62.68 7.08 0 0 .62-8.3.62-17.98s-.62-17.99-.62-17.99c23.23 7.77 49.31 7.25 62.68 7.03v-32.37c-12.19-.1-29.74.48-49.6 7.12 0 0 .62-8.3.62-17.98s-.62-17.98-.62-17.98c19.83 6.62 37.36 7.22 49.54 7.11-.62-20.5-6.6-46.33-6.6-46.33s12.3.96 17.22.96c4.92 0 17.21-.96 17.21-.96s-5.97 25.83-6.6 46.33c12.18.1 29.72-.49 49.55-7.11 0 0-.62 8.3-.62 17.98 0 9.67.62 17.98.62 17.98-19.86-6.64-37.42-7.22-49.6-7.12v32.37"></path>
    <path fill="#254aa5" d="M270 329.1c-24.87 0-38.19 34.46-38.19 34.46s-7.4-16.34-27.68-16.34c-13.73 0-23.82 12.2-30.25 23.5 24.97 39.7 64.8 64.2 96.11 79.28 31.32-15.07 71.16-39.58 96.13-79.28-6.43-11.3-16.52-23.5-30.25-23.5a30.52 30.52 0 0 0-27.69 16.34s-13.32-34.46-38.19-34.46Z"></path>
  </symbol>
</svg>
